<div
    class="sweet-overlay"
    tabindex="-1"
    style="opacity: 1.08"
    [ngStyle]="{ display: _gone ? 'none' : 'block' }"></div>
<div
    class="sweet-alert shadow-sm p-4 p-xl-5 {{ data?.customAlert?.styleClass }}"
    data-custom-class=""
    data-has-cancel-button="false"
    data-has-confirm-button="true"
    data-allow-outside-click="false"
    data-has-done-function="false"
    data-animation="pop"
    data-timer="null"
    [ngStyle]="{ 'margin-top': marginTop, 'width.px': data?.customAlert?.width || 478 }"
    [ngClass]="{
        showSweetAlert: _showModal && !_gone,
        hideSweetAlert: !_showModal && !_gone,
        'confirm-alert': data.confirmAction !== null
    }">
    <div
        *ngIf="data.errors.length"
        class="sa-icon sa-error">
        <span class="sa-x-mark">
            <span class="sa-line sa-left"></span>
            <span class="sa-line sa-right"></span>
        </span>
    </div>

    <div
        *ngIf="data.notifications.length || data.statusUpdate"
        class="d-block sa-icon sa-success animate">
        <span class="sa-line sa-tip animateSuccessTip"></span>
        <span class="sa-line sa-long animateSuccessLong"></span>

        <div class="sa-placeholder"></div>
        <div class="sa-fix"></div>
    </div>

    <!-- simple text modal -->
    <ng-container *ngIf="data.simple !== null">
        <p style="color: #7b7b7b">{{ data.simple.message }}</p>
        <div class="mt-4 d-flex justify-content-center align-items-center">
            <a
                class="btn {{ data.simple.okClass }} btn-thin"
                (click)="close()"
                >{{ data.simple.okText }}</a
            >
        </div>
    </ng-container>

    <!-- Custom template contents -->
    <ng-container
        *ngIf="data.customAlert !== null"
        style="display: block">
        <div #templateCont>
            <ng-container *ngTemplateOutlet="data.customAlert.template"></ng-container>
        </div>
        <div class="buttons-holder">
            <a
                class="btn-styled--secondary"
                (click)="close()"
                *ngIf="data.customAlert.cancelText !== null"
                >{{ data.customAlert.cancelText }}</a
            >&nbsp;
            <a
                class="btn-styled {{ data.customAlert.confirmClass }}"
                [ngClass]="{ 'is-invalid': data.customAlert.canConfirmCb && data.customAlert.canConfirmCb() !== true }"
                (click)="confirm()"
                >{{ data.customAlert.confirmText }}</a
            >
        </div>
    </ng-container>

    <!-- Confirmation modal -->
    <ng-container *ngIf="data.confirmAction !== null">
        <h2 class="confirm-alert-title-holder">{{ data.confirmAction.title }}</h2>
        <div class="confirm-alert-message-holder">{{ data.confirmAction.message }}</div>
        <div class="confirm-alert-buttons-holder">
            <a
                class="btn-styled--secondary"
                (click)="close()"
                >{{ data.confirmAction.cancelText }}</a
            >&nbsp;
            <a
                class="btn-styled"
                [ngClass]="data.confirmAction.confirmClass"
                (click)="confirm()"
                >{{ data.confirmAction.confirmText }}</a
            >
        </div>
    </ng-container>

    <!-- Input modal -->
    <ng-container *ngIf="data.simpleInput !== null">
        <h2 class="text-center">{{ data.simpleInput.title }}</h2>
        <p style="color: #7b7b7b">{{ data.simpleInput.message }}</p>
        <form
            [formGroup]="form"
            autocomplete="off">
            <input
                class="form-control"
                formControlName="myInput"
                type="{{ data.simpleInput.inputType }}"
                placeholder="{{ data.simpleInput.inputPlaceHolder }}"
                pattern="{{ data.simpleInput.inputPattern }}"
                required="{{ data.simpleInput.inputRequired }}"
                [ngClass]="{ 'is-invalid': form.controls.myInput.invalid && form.controls.myInput.touched }" />
            <div class="invalid-feedback">{{ data.simpleInput.inputErrorMsg }}</div>
        </form>
        <div
            class="text-center"
            style="margin-top: 20px">
            <a
                class="btn btn-white ms-2"
                (click)="close()"
                >{{ data.simpleInput.cancelText }}</a
            >&nbsp;
            <a
                class="btn {{ data.simpleInput.confirmClass }}"
                [ngClass]="{ disabled: form.controls.myInput.invalid }"
                (click)="confirm()"
                >{{ data.simpleInput.confirmText }}</a
            >
        </div>
    </ng-container>

    <ng-container *ngIf="data.notifications.length">
        <div class="fs-4 fw-bold text-center">Success</div>
        <hr class="bg-primary" />
        <p
            class="lh-lg d-block text-center"
            *ngFor="let message of data.notifications"
            [innerHTML]="message"></p>
        <div class="mt-4 d-flex justify-content-center align-items-center">
            <button
                class="btn btn-primary btn-thin"
                tabindex="1"
                (click)="close()">
                Ok
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="data.errors.length">
        <div class="fs-4 fw-bold text-center">Error</div>
        <hr class="bg-primary" />
        <p
            class="d-block text-center"
            *ngFor="let message of data.errors">
            {{ message }}
        </p>
        <div class="mt-4 d-flex justify-content-center align-items-center">
            <button
                class="btn btn-primary btn-thin"
                tabindex="1"
                (click)="close()">
                Ok
            </button>
        </div>
    </ng-container>
</div>
